"use strict";

exports["default"] = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/class-call-check.js
 ** module id = 3
 ** module chunks = 0
 **/